import { agentsLookupConstants } from '@constants/agents';

const initialState = {
    data: [],
    loading: true,
};

export function agentsLookup(state = initialState, action) {
    switch (action.type) {
        case agentsLookupConstants.AGENTS_LOOKUP_FETCH:
            return { ...state, loading: true };
        case agentsLookupConstants.AGENTS_LOOKUP_SUCCESS:
            return { ...state, loading: false, data: action.data };
        case agentsLookupConstants.AGENTS_LOOKUP_ERROR:
            return { ...state, loading: false };
        default:
            return state;
    }
}
